import { render } from "./LicensesTable.vue?vue&type=template&id=ef974dd4&scoped=true"
import script from "./LicensesTable.vue?vue&type=script&lang=js"
export * from "./LicensesTable.vue?vue&type=script&lang=js"

import "./LicensesTable.vue?vue&type=style&index=0&id=ef974dd4&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ef974dd4"]])

export default __exports__